
export enum TreeViewOrigin {
    Header = 0,
    Other = 1
}

export enum ResponseStatus {
    Success = 0,
    Error = 1,
    Information = 2,
    Warning = 3,
    TimeOut = 6
}